import React, { useEffect, useRef } from 'react';
import { Routes, Route, BrowserRouter, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingInfoButton from './components/FloatingInfoButton';
import HomePage from './pages/HomePage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AirfieldInfoPage from './pages/AirfieldInfoPage';
import NotFoundPage from './pages/NotFoundPage';
import { CookieProvider } from './contexts/CookieContext';
import CookieBanner from './components/CookieBanner';

// Bei Seitenwechsel ohne Anker nach oben scrollen (Links im Footer etc.); beim ersten Laden nicht eingreifen
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!hash) window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
};

function App() {
  return (
    <CookieProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <a href="#main-content" className="skip-to-content">Zum Inhalt springen</a>
          <Header />
          <main id="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/flugplatzinfo" element={<AirfieldInfoPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </main>
          <FloatingInfoButton />
          <Footer />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </CookieProvider>
  );
}

export default App;
